<template lang="html">
  <transition
    name="noti"
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
  >
    <div
      v-if="active && typeNotify == 1"
      ref="noti"
      :style="stylex"
      :class="[`vs-noti-${position}`,`vs-noti-${color}`,{'activeNoti':active}]"
      class="vs-component vs-notifications flex items-center"
      @click="clickNoti">
        <div>
          <ms-icon
            :icon="icon"
            class="p-relative toast-icon"
            style="z-index:9"
          ></ms-icon>
        </div>
        <div>
          <div class="content-noti">
            <div class="con-text-noti">
              <p v-html="text"/>
              <slot/>
            </div>
          </div>
        </div>
    </div>
    <div
      v-if="active && typeNotify == 2"
      ref="noti"
      :style="stylex"
      :class="[`vs-noti-${position}`,`vs-noti-${color}-2`,{'activeNoti':active}]"
      class="vs-component vs-notifications flex items-center"
      @click="clickNoti">
        <div class="flex items-center">
          <ms-icon
            :icon="icon"
            class="p-relative toast-icon m-l-16"
            style="z-index:9"
          ></ms-icon>
          <p class="m-l-4 text-notify p-0" v-html="notifyText"/>
        </div>
        <div>
          <div class="content-noti p-r-4">
            <div class="con-text-noti">
              <p class="p-0" v-html="text"/>
              <slot/>
            </div>
          </div>
        </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "MsNotification",
  props: {
    showIcon: {
      type: [String, Boolean],
      default: true
    }
  },
  data: () => ({
    typeNotify: 1,
    type: "info",
    fullWidth: false,
    icon: null,
    color: "primary",
    colorText: "#363a36",
    active: true,
    text: null,
    title: null,
    position: "top-center",
    time: 3000,
    cords: {
      top: null,
      left: null,
      right: null,
      bottom: null
    },
    widthx: 0,
    fixed: false,
    notifyText: "Thành công"
  }),
  computed: {
    stylex() {
      return {
        ...this.cords,
        color: this.colorText,
        width: this.fullWidth ? `calc(100% - 14px)` : ``,
        maxWidth: this.fullWidth ? "max-content" : `350px`
      };
    },
  },
  created() {
    setTimeout(() => {}, 0);
    this.changeCords();
  },
  mounted() {
    setTimeout(() => {
      this.widthx = this.$refs.noti.clientWidth;
    }, 0);

    if (!this.fixed) {
      setTimeout(() => {
        this.closeNoti();
      }, this.time);
    }
  },
  methods: {
    clickNoti() {
      this.active = false;
      this.click ? this.click() : null;
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.style.opacity = 1;
      done();
    },
    leave(el, done) {
      el.style.opacity = 0;
      let transformx = el.style.transform;
      if (this.cords.left == "50%" || this.fullWidth) {
        transformx += ` translateY(${this.cords.top ? "-" : ""}100%)`;
      } else {
        transformx += ` translateX(${this.cords.left ? "-" : ""}100%)`;
      }
      el.style.transform = transformx;
      setTimeout(() => {
        done();
      }, 150);
    },
    closeNoti() {
      this.active = false;
    },
    changeCords() {
      let positions = this.position.split("-");
      let search = text => {
        return positions.indexOf(text) != -1;
      };
      if (search("top")) {
        this.cords.top = "0px";
      }
      if (search("bottom")) {
        this.cords.bottom = "0px";
      }
      if (search("right")) {
        this.cords.right = "0px";
      }
      if (search("left")) {
        this.cords.left = "0px";
      }

      if (search("center")) {
        this.cords.right = "calc(50% - 80px)";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/msNotification.scss";
</style>
